module.exports = __webpack_public_path__ + "img/案例顶部图.31e51b4e.png";